/**
 * Chat API Endpoints
 * Centralized endpoint definitions for messaging/chat features
 * Base URL: http://127.0.0.1:1111 (from .env)
 * Prefix: /frontend/chat
 */

const CHAT_ENDPOINTS = {
  // Conversations
  GET_CONVERSATIONS: "/frontend/chat/conversations",
  GET_CONVERSATION_BY_ID: (conversationId) => `/frontend/chat/conversations/${conversationId}`,
  START_CONVERSATION: (userId) => `/frontend/chat/conversations/${userId}`,
  DELETE_CONVERSATION: (conversationId) => `/frontend/chat/conversations/${conversationId}`,
  
  // Messages
  GET_MESSAGES: (conversationId) => `/frontend/chat/conversations/${conversationId}/messages`,
  EDIT_MESSAGE: (messageId) => `/frontend/chat/messages/${messageId}`,
  DELETE_MESSAGE: (messageId) => `/frontend/chat/messages/${messageId}`,
  
  // Mark as Read
  MARK_MESSAGE_AS_READ: (messageId) => `/frontend/chat/messages/${messageId}/read`,
  MARK_ALL_AS_READ: (conversationId) => `/frontend/chat/conversations/${conversationId}/read`,
  
  // Unread Count
  GET_UNREAD_COUNT: "/frontend/chat/unread-count",
  
  // Search
  SEARCH_MESSAGES: "/frontend/chat/search",
  
  // File Upload
  UPLOAD_IMAGE: "/frontend/chat/upload-image",
};

export default CHAT_ENDPOINTS;
